import { NavLink } from 'react-router-dom';
import { styled } from '@linaria/react';
import { COLORS, typographyStyles, Icon, DirectionalIcon } from '@livecommerce/design-system';
import { css } from '@linaria/core';
export const { getBodyText } = typographyStyles;

export const navigationLinkStyles = css`
  display: flex;
  padding: 10px;
  align-items: center;
  border: none;
  width: 100%;
  border-radius: 6px;
  color: ${COLORS.dark_700};
  text-decoration: none;
  overflow: hidden;

  &:hover {
    background-color: ${COLORS.white};
  }

  .menu-icon {
    display: flex;
  }

  &.active {
    background-color: ${COLORS.white};
  }
`;

export const disabledNavigationLinkStyles = css`
  opacity: 0.15;
  pointer-events: none;
  cursor: default;

  &:hover {
    background-color: transparent;
  }

  &.active {
    background-color: transparent;
  }
`;

export const StyledIcon = styled(Icon)`
  flex-shrink: 0;
`;

export const ExpandSubMenuButton = styled.button`
  display: flex;
  padding: 10px;
  align-items: center;
  border: none;
  width: 100%;
  border-radius: 6px;
  background-color: ${(props) => (props.active ? 'white' : 'transparent')};
  color: ${COLORS.dark_700};
  text-decoration: none;
  overflow: hidden;
  cursor: pointer;

  .submenu-chevron {
    visibility: hidden;
  }

  &:hover {
    background-color: ${COLORS.white};

    .submenu-chevron {
      visibility: visible;
    }
  }
`;

export const NavigationListItemTitle = styled.p`
  ${getBodyText(16)};
  margin: 0 0 0 24px;
  white-space: nowrap;
`;

export const NavigationListItemSubtitle = styled.p`
  ${getBodyText(14)};
  margin: 0 0 0 24px;
  white-space: nowrap;
`;

export const SubMenu = styled.ul`
  display: flex;
  padding: 0;
  flex-direction: column;
  margin-top: 8px;
  list-style-type: none;
  > li {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const SubMenuWrapper = styled.div`
  overflow-y: hidden;
`;

export const SubMenuLink = styled(NavLink)`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  border: none;
  width: 100%;
  border-radius: 6px;
  color: ${COLORS.blackLight};
  text-decoration: none;
  overflow: hidden;

  &:hover {
    background-color: ${COLORS.white};
  }

  svg {
    visibility: hidden;
  }

  &.active {
    background-color: ${COLORS.white};

    svg {
      visibility: visible;
    }
  }
`;

export const StyledArrow = styled(DirectionalIcon)`
  flex-shrink: 0;
`;

export const StyledChevron = styled(DirectionalIcon)`
  margin-left: auto;
`;
